import styles from './domain-dialog.module.scss';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, PrimaryButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface DomainDialogProps {
  open: boolean,
  onClose: () => void,
  initialDomains: string[],
  licenseNumber: number
}

export function DomainDialog(props: DomainDialogProps) {
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const [domains, setDomains] = useState<string[]>(props.initialDomains);


  const handleDomainChange = (event: any) => setDomains(event.target.value.split(","));

  const handleChange = () => {
    makeRequest(`Licenses/${props.licenseNumber}/action/changeDomains`, 'PUT', {
      domains: domains,
      companyNumbers: []
    }).then(value => {
      setSnackbarMessage({ content: t('domain.automaticDomainApprovalDone'), type: "success" });
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('domain.failedToPerformAutomaticDomainValidation'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t('domain.automaticDomainApproval')}
      </DialogTitle>
      <DialogContent>
        <div className="d-flex flex-column mb-4">
          <div className='mb-3'>
            <TextField
              fullWidth
              label={t('standard.domain')}
              name='domains'
              value={domains}
              onChange={handleDomainChange}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleChange}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DomainDialog;